import { IStringifyOptions } from 'qs';

export const envEncoder: IStringifyOptions['encoder'] = (
  value,
  defaultEncoder
) => {
  if (process.env.APP_ENV === 'test') {
    return value === '*' ? value : defaultEncoder(value);
  }
  return defaultEncoder(value);
};

export const filterNaNToNull: IStringifyOptions['filter'] = (_, value) =>
  Number.isNaN(value) ? null : value;
